import Axios from "axios";
import Vue from "vue";
import qs from "qs";
import store from "../store";
import { baseUrl } from "@/utils/host";

Axios.defaults.baseURL = baseUrl;
// Axios.defaults.timeout = 10000;// 响应时间
Axios.defaults.withCredentials = true; //设置cookie有效
// Axios.defaults.headers.common['X-Access-Token'] = Token;
// Axios.defaults.headers.post['Content-type'] = 'application/x-www-form-urlencoded';
Axios.interceptors.request.use(
  (config) => {
    // console.log(config);
    //设置拐带Token 请求头
    if (store.state.AcceptLanguage) {
      config.headers.common["Accept-Language"] = store.state.AcceptLanguage;
      // config.headers.common["currency"] = store.state.AcceptLanguage == 1 ? 1 : 0;
      if (store.state.SourceType == 0 || store.state.SourceType) {
        config.headers.common["Source-Type"] = store.state.SourceType; //Source-Type  会员来源 0:国内 1:海外
      }

      // console.log(store.state.Token,'设置拐带Token 请求头');
    }

    // currency 0-港元 1-美元
    config.headers.common['currency'] = store.state.locale === 'en' ? 1 : 0

    //判断config.data.constructor不是formdata，则不qs格式化data
    if (
      config.data &&
      config.method === "post" &&
      config.data.constructor !== FormData
    ) {
      config.data = qs.stringify(config.data, { arrayFormat: "repeat" }); //数组需要格式化一下，格式化模式有三种：indices、brackets、repeat
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * 公共请求入口
 * @param param 'object  参数'
 * @param url   'string  接口'
 * @param type  'get || post'
 * @returns {Promise}
 */
export const commonPromise = (type, url, param = {}) => {
  return new Promise((resolve) => {
    let request;
    if (type === "post") {
      request = Axios({
        url: url,
        method: type,
        data: param,
      });
    } else {
      request = Axios({
        url: url,
        method: "get",
        params: param,
      });
    }
    request.then((res) => {
      // console.log(res,'返回所有的信息');
      if (res.data.code == 200) {
        resolve(res.data);
      } else {
        if (res.data.msg) {
          resolve(res.data);
        }
      }
    });
  });
};
